export default "__VITE_ASSET__BdkHBeRl__"